import React from 'react';
import { ArrowUpRightIcon, CameraIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { ButtonLink } from '../ButtonLink';
import { Eyebrow } from '../Eyebrow';
import { contact, urls } from '../../data/site';
export function QuoteHelpPanel() {
  return <aside aria-labelledby="quote-help-heading" className="bg-ink p-7 text-paper md:p-9" data-id="element-328" data-mp="2ddlfobfzqas9">
      <Eyebrow tone="dark" data-id="element-329" data-mp="28izfl4fd04nh">Prefer to talk?</Eyebrow>
      <h2 id="quote-help-heading" className="mt-4 font-display text-[30px] font-bold uppercase leading-none" data-id="element-330" data-mp="2ndcdalzul5wk">
        Call the shop
      </h2>
      <a href={contact.phoneHref} className="mt-4 inline-block font-display text-[40px] font-bold leading-none tracking-[0.01em] text-paper underline decoration-brand decoration-2 underline-offset-8 transition-colors duration-150 ease-out hover:text-brand-bright" data-id="element-331" data-mp="2icydfr8eh29m">
        {contact.phoneDisplay}
      </a>
      <ButtonLink href={contact.phoneHref} variant="outlineDark" leadingIcon={PhoneIcon} className="mt-6 w-full md:h-12" data-id="element-332" data-mp="315sh3p0kp7yj">
        Call {contact.phoneDisplay}
      </ButtonLink>

      <div className="mt-8 border-t border-ink-line pt-6" data-id="element-333" data-mp="7muq8byxydbk">
        <address className="flex items-start gap-3 text-[15px] not-italic leading-relaxed text-steel-light" data-id="element-334" data-mp="7ph9v9z3wja5">
          <MapPinIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-bright" data-id="element-335" data-mp="gocewiqeznbv" />
          <span data-id="element-336" data-mp="lnf9tacokd64">
            <span className="block font-semibold text-paper" data-id="element-337" data-mp="lnp43a4rd6hm">{contact.name}</span>
            {contact.street}
            <br data-id="element-338" data-mp="qlqk1m6w0pov" />
            {contact.cityLine}
          </span>
        </address>
        <a href={urls.directions} target="_blank" rel="noopener noreferrer" className="ml-7 mt-2 inline-flex min-h-[44px] items-center gap-1.5 text-[15px] font-semibold text-paper underline decoration-brand underline-offset-4" data-id="element-339" data-mp="vdh088sia7o7">
          Get directions
          <ArrowUpRightIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-340" data-mp="19cqbqv5rodlu" />
        </a>
      </div>

      <p className="mt-6 flex items-start gap-3 border-t border-ink-line pt-6 text-[15px] leading-relaxed text-steel-light" data-id="element-341" data-mp="35fv3yd0paxwx">
        <CameraIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-bright" data-id="element-342" data-mp="31fkom9r0qv5e" />
        <span data-id="element-343" data-mp="3f67q29o5yz56">
          Photos are optional. Damage photos or paint references can help show the work needed.
        </span>
      </p>
    </aside>;
}